import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AiPromptArgument } from 'src/app/core/models/ai-prompt-argument';
import { DialogResult } from 'src/app/shared/atlas-dialog/enums/dialog-result.enum';
import { AiPromptArgumentsFormComponent } from '../ai-prompt-arguments-form/ai-prompt-arguments-form.component';

@Component({
    selector: 'ai-prompt-arguments-dialog',
    templateUrl: './ai-prompt-arguments-dialog.component.html',
    styleUrl: './ai-prompt-arguments-dialog.component.less',
    standalone: false
})
export class AiPromptArgumentsDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AiPromptArgumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      arguments: AiPromptArgument[];
    }
  ) {}

  onConfirmButtonClicked(formComponent: AiPromptArgumentsFormComponent) {
    const argumentRecord: Record<string, unknown> = {};
    Object.keys(formComponent.argumentsForm.controls).forEach((key) => {
      argumentRecord[key] = formComponent.argumentsForm.controls[key].value;
    });

    this.dialogRef.close({
      action: DialogResult.Affirmative,
      data: argumentRecord
    });
  }
}
